import { FileMetadata } from '@assethub/shared/models';
import { PresignedUrl } from '@assethub/shared/models';

export interface DownloadMetadata extends FileMetadata, PresignedUrl {}
